export enum ProfileMenuType {
  FULL_NAME = "FULL_NAME",
  JOB_OFFER = "JOB_OFFER",
  EMAIL = "EMAIL",
  COUNTRY = "COUNTRY",
  PHONE_NUMBER = "PHONE_NUMBER",
  GENDER = "GENDER",
  LINK = "LINK",
  SKILL = "SKILL",
  ABOUT_ME = "ABOUT_ME",
  ACTIVITY_HISTORIES = "ACTIVITY_HISTORIES",
  WORK_EXPERIENCE = "WORK_EXPERIENCE",
  EDUCATION = "EDUCATION"
}